module.exports = __webpack_public_path__ + "static/media/Group 1799.fad27634.png";